/**
 * Единый флаг mock-режима данных для всех API-модулей.
 *
 * По умолчанию приложение работает на РЕАЛЬНОМ backend colver;
 * демо-режим на моках включается явно: `VITE_USE_MOCK=true`.
 */
export const IS_MOCK = import.meta.env.VITE_USE_MOCK === 'true';
